import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NbJSThemeOptions, NbThemeService } from '@nebular/theme';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-range-slider',
  templateUrl: './range-slider.component.html',
  styleUrls: ['./range-slider.component.scss']
})
export class RangeSliderComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("slider") slider!: ElementRef<HTMLElement>;
  @Input() initialValue!: number;
  @Input() minValue = 0;
  @Input() maxValue = 100;
  @Output() changedInput = new EventEmitter();

  form!: UntypedFormGroup;

  private theme: NbJSThemeOptions;
  private subscription = new Subscription();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private nbThemeService: NbThemeService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      tip: [this.initialValue]
    });

    this.subscription.add(
      this.nbThemeService
        .getJsTheme()
        .subscribe(res => {
          this.theme = res
          this.slider && this.setValues();
        })
    );
  }

  ngOnDestroy(): void {
    this.changedInput.emit(this.initialValue);
    this.subscription.unsubscribe();
  }

  ngAfterViewInit() {
    this.setValues();
    const slider = this.slider.nativeElement as HTMLElement;
    slider.oninput = () => {
      this.setValues();
      this.changedInput.emit(this.form.value.tip);
    };
  }

  setValues() {
    const slider = this.slider.nativeElement as HTMLElement;
    const colorFilled = this.theme.variables!['rangeSliderFilled'];
    const colorEmpty = this.theme.variables!['rangeSliderEmpty'];

    const styleFilled = `${colorFilled} 0%, ${colorFilled} ${this.form.value.tip * 100 / this.maxValue}%`;
    const styleEmpty = `${colorEmpty} ${this.form.value.tip * 100 / this.maxValue}%, ${colorEmpty}`;
    
    slider.style.background = `linear-gradient(to right, ${styleFilled}, ${styleEmpty})`;
  }
}
